import { GET, PUT, POST } from "utils/fetcher";

export const requestData = type => () => ({ type });
export const succeedData = type => ({ data }) => ({ data, type });
export const failedData = type => error => ({ error, type });

export const RESET_CURRENT_INTEGRATION = Symbol("RESET_CURRENT_INTEGRATION");
export const resetCurrent = () => ({ type: RESET_CURRENT_INTEGRATION });

export const RESETALL_INTEGRATIONS = Symbol("RESETALL_INTEGRATIONS");
export const resetAll = () => ({ type: RESETALL_INTEGRATIONS });

export const CREATE_INTEGRATION_REQUESTED = Symbol(
	"CREATE_INTEGRATION_REQUESTED"
);
export const CREATE_INTEGRATION_SUCCEED = Symbol("CREATE_INTEGRATION_SUCCEED");
export const CREATE_INTEGRATION_FAILED = Symbol("CREATE_INTEGRATION_FAILED");

export function create(
	{ organizationId, integration = "skidata", data },
	signal
) {
	return request(
		`/bo/organizers/${organizationId}/integrations/${integration}`,
		[JSON.stringify(data), signal],
		{
			request: requestData(CREATE_INTEGRATION_REQUESTED),
			success: succeedData(CREATE_INTEGRATION_SUCCEED),
			failed: failedData(CREATE_INTEGRATION_FAILED)
		},
		POST
	);
}

export const RETRIEVE_INTEGRATIONS_REQUESTED = Symbol(
	"RETRIEVE_INTEGRATIONS_REQUESTED"
);
export const RETRIEVE_INTEGRATIONS_SUCCEED = Symbol(
	"RETRIEVE_INTEGRATIONS_SUCCEED"
);
export const RETRIEVE_INTEGRATIONS_FAILED = Symbol(
	"RETRIEVE_INTEGRATIONS_FAILED"
);

export function getAll({ organizationId, integration = "skidata" }, signal) {
	return request(
		`/bo/organizers/${organizationId}/integrations/${integration}`,
		[false, signal],
		{
			request: requestData(RETRIEVE_INTEGRATIONS_REQUESTED),
			success: succeedData(RETRIEVE_INTEGRATIONS_SUCCEED),
			failed: failedData(RETRIEVE_INTEGRATIONS_FAILED)
		}
	);
}

export const RETRIEVE_ONE_INTEGRATION_REQUESTED = Symbol(
	"RETRIEVE_ONE_INTEGRATION_REQUESTED"
);
export const RETRIEVE_ONE_INTEGRATION_SUCCEED = Symbol(
	"RETRIEVE_ONE_INTEGRATION_SUCCEED"
);
export const RETRIEVE_ONE_INTEGRATION_FAILED = Symbol(
	"RETRIEVE_ONE_INTEGRATION_FAILED"
);

export function getOne(
	{ organizationId, integration = "skidata", id },
	signal
) {
	return request(
		`/bo/organizers/${organizationId}/integrations/${integration}/${id}`,
		[false, signal],
		{
			request: requestData(RETRIEVE_ONE_INTEGRATION_REQUESTED),
			success: succeedData(RETRIEVE_ONE_INTEGRATION_SUCCEED),
			failed: failedData(RETRIEVE_ONE_INTEGRATION_FAILED)
		}
	);
}

export const UPDATE_INTEGRATION_REQUESTED = Symbol(
	"UPDATE_INTEGRATION_REQUESTED"
);
export const UPDATE_INTEGRATION_SUCCEED = Symbol("UPDATE_INTEGRATION_SUCCEED");
export const UPDATE_INTEGRATION_FAILED = Symbol("UPDATE_INTEGRATION_FAILED");

export function update(
	{ organizationId, integration = "skidata", data, id },
	signal
) {
	return request(
		`/bo/organizers/${organizationId}/integrations/${integration}/${id}`,
		[JSON.stringify(data), signal],
		{
			request: requestData(UPDATE_INTEGRATION_REQUESTED),
			success: succeedData(UPDATE_INTEGRATION_SUCCEED),
			failed: failedData(UPDATE_INTEGRATION_FAILED)
		},
		PUT
	);
}

function request(url, params, { request, success, failed }, action = GET) {
	return dispatch => {
		if (request) {
			dispatch(request());
		}
		// Call the action of the Fetcher
		return action(url, ...params)
			.then(response => {
				// Return the data to the next then
				return { data: response.data };
			})
			.then(res => {
				// Return res and call redux
				if (success) {
					dispatch(success(res));
				}
				return res;
			})
			.catch(error => {
				// Return error and call redux
				if (failed) {
					dispatch(failed(error));
				}
				return error;
			});
	};
}
